import mapValues from "lodash/mapValues";

// TODO: update return type
export const nullValuesToUndefined = <T extends object>(
  data: T | null | undefined
) => mapValues(data, (value) => (value === null ? undefined : value)) as T;
